export default __webpack_public_path__ + "static/media/tool_googlemaps.71d74424.png";